export default __webpack_public_path__ + "static/media/How-to-play-DuudleAI.3e1463f2.jpg";